import { BLACK_KEY_ACCESS_CONTENT } from '../constants/blackKeyAccessContent'

function ColumnBullets({ heading, bullets }) {
  return (
    <section className="px-5 py-8 sm:px-7 sm:py-10">
      <h3 className="font-AXONALLPrimeSemiBold text-base sm:text-lg text-black tracking-tight mb-6">
        {heading}
      </h3>
      <ul className="list-none space-y-4 sm:space-y-5 pl-0">
        {bullets.map((text, i) => (
          <li
            key={i}
            className="flex gap-3 font-poppinsLight text-[15px] sm:text-base leading-[1.65] text-neutral-800"
          >
            <span className="mt-[0.55em] h-1 w-1 flex-shrink-0 rounded-full bg-black" aria-hidden />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </section>
  )
}

const BlackKeyAccessWelcomePack = () => {
  const c = BLACK_KEY_ACCESS_CONTENT

  return (
    <div className="text-black">
      <h2 className="font-AXONALLPrimeSemiBold text-center text-xl sm:text-2xl md:text-[1.75rem] uppercase tracking-[0.06em] text-black mb-10 sm:mb-12">
        {c.title}
      </h2>

      <div className="max-w-[90%] sm:max-w-2xl mx-auto border border-black bg-neutral-100/80 px-5 py-6 sm:px-8 sm:py-7 mb-12 sm:mb-14">
        <p className="font-poppinsLight text-[15px] sm:text-base leading-[1.65] text-neutral-800 text-center">
          {c.summary}
        </p>
      </div>

      <div className="border border-black overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="border-b md:border-b-0 md:border-r border-black bg-white">
            <ColumnBullets heading={c.reflects.heading} bullets={c.reflects.bullets} />
          </div>
          <div className="bg-neutral-50">
            <ColumnBullets heading={c.regarded.heading} bullets={c.regarded.bullets} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BlackKeyAccessWelcomePack
